<template>
	<form
		:class="[
			'input-sigarus',
			{ 'align-right': type.includes('number') || type.includes('id') || type.includes('go')}, 
			{ editing }, 
			{ editable: !readonly },
			input ? input.class : ''
		]"
		v-click-outside="cancel"
		@submit.prevent="save"
		@keydown.enter="type == 'textarea' ? '' : save"
		@keydown.ctrl.enter.stop.prevent="save"
		@keydown.esc.capture="cancel"
		@input="error = false"
		@keydown.shift.tab.exact="back"
		@keydown.tab.exact="next"
		novalidate="true"
	>

		<el-popover
			v-if="mode === 'inline'"
			v-model="showTooltip"
			placement="top"
			title=""
			trigger="manual">

			<el-alert v-if="error" type="error" effect="dark" :closable="false">{{ error }}</el-alert>

			<div
				ref="a"
				class="holder"
				slot="reference"
				@click="ondblclick"
			>

				<div
					v-show="!editing && !hideInput"
					class="label"
				>	
					<el-input 
						v-if="type == 'textarea'"
						type="textarea"
						rows="4"
						readonly
						:value="value"/>
					<template v-else>
						<div v-if="[null,''].includes(value)" class="placeholder truncate">
							{{ placeholder }}
						</div>
						<div v-else class="truncate">
							<div v-if="typeof value == 'object' && value.length <= 0" style="min-height: 20px;"></div>
							<div v-else v-html="`${input && input.textpre ? input.textpre : ''} ${render(value)} ${input && input.textpos ? input.textpos : ''}`"></div>
						</div>
					</template>

				</div>

				<div :class="[{ editing }]" :style="{'flex-shrink': ['id'].includes(extraType) ? 0 : 1}">
					
					<component
						v-show="editing"
						ref="input"
						class="input-sigarus-component"
						:is="`l-${mainType}`"
						:key="`l-${mainType}`"
						:editing="editing"
						size="small"
						v-model="model"
						v-bind.sync="{...$attrs, ...$props}"
						@focus="$emit('focus')"
						@blur="$emit('blur')"
						@input="onInput"
						@save="save"
					/>

					<div v-show="editing && showDeleteButton" class="buttons buttons-editing">
						<el-button
							title="Cancelar"
							size="small"
							circle
							type="danger"
							@click.stop.prevent="cancel"
							icon="el-icon-close"
						></el-button>
					</div>

					<div v-if="extraType" class="buttons">

						<el-button
							v-if="['id','go'].includes(extraType)"
							title="Ver"
							size="small"
							@click.stop.prevent="$emit('go', input)"
							icon="el-icon-link"
						></el-button>

						<el-button
							v-if="['id'].includes(extraType)"
							title="Editar"
							size="small"
							:disabled="input.state == 'read-only'"
							@click.stop.prevent="$emit('id', input)"
							icon="el-icon-edit-outline"
						></el-button>

						<!-- Acciones -->
						<el-tooltip
							v-for="action,a in actions"
							:key="a"
							class="item" 
							effect="dark" 
							:content="action ? action.titulo : ''" 
							placement="top">
								<el-button
								v-if="action"
								@click="porlet.events.clickAction(action)"
								type="default" 
								size="mini" 
								:icon="action.icon"
								/>
						</el-tooltip>

					</div>

				</div>

			</div>

		</el-popover>

		<div class="popover" v-else>

			<el-popover
				v-model="showTooltip"
				placement="top"
				title="Editar"
				trigger="manual"
			>

				<div class="holder">

					<el-alert
						v-if="error"
						type="error"
						effect="dark"
						:closable="false"
						style="margin-bottom: 10px;"
					>{{ error }}</el-alert>

					<div>
						
						<component
							ref="input"
							class="input-sigarus-component"
							:is="`l-${mainType}`"
							:key="`l-${mainType}`"
							:editing="editing"
							size="small"
							v-model="model"
							v-bind.sync="{...$attrs, ...$props}"
							@focus="$emit('focus')"
							@blur="$emit('blur')"
							@input="onInput"
							@save="save"
						/>
						<div v-show="editing && showDeleteButton" class="buttons buttons-editing">
							<el-button
								title="Cancelar"
								size="small"
								circle
								type="danger"
								@click.stop.prevent="cancel"
								icon="el-icon-close"
							></el-button>
						</div>

						<div v-if="extraType" class="buttons">

							<el-button
								v-if="['id','go'].includes(extraType)"
								title="Ver"
								size="small"
								@click.stop.prevent="$emit('go', input)"
								icon="el-icon-link"
							></el-button>

							<el-button
								v-if="['id'].includes(extraType)"
								title="Editar"
								size="small"
								:disabled="input.state == 'read-only'"
								@click.stop.prevent="$emit('id', input)"
								icon="el-icon-edit-outline"
							></el-button>

							<!-- Acciones -->
							<el-tooltip
								v-for="action,a in actions"
								:key="a"
								class="item" 
								effect="dark" 
								:content="action ? action.titulo : ''" 
								placement="top">
									<el-button
									v-if="action"
									@click="porlet.events.clickAction(action)"
									type="default" 
									size="mini" 
									:icon="action.icon"
									/>
							</el-tooltip>

						</div>

					</div>

				</div>

				<div
					v-show="!hideInput"
					ref="a"
					slot="reference"
					class="label"
					@click="ondblclick"
				>

					<div v-html="render(value)"></div>

				</div>

			</el-popover>

		</div>

	</form>
</template>

<script>
	import axios from 'axios'
	import _ from 'lodash'
	import inputConfig from './utils/inputConfig'
	
	import {updateInputFile} from '@/helpers/api'

	import moment from 'moment'

	export default {
		name: 'InputSigarus',
		components: inputConfig,
		props: {
			obligatorio: {
				type: Boolean
			},
			identificador: {
				type: [String,Number]
			},
			entidad: {
				type: String
			},
			input: {
				type: Object
			},
			value: {
				default: ''
			},
			type: {
				type: String,
				default: 'text'
			},
			saveUrl: {
				type: String,
				default: ''
			},
			mode: {
				type: String,
				default: 'inline'
			},
			siblings: {
				type: Array,
				default: () => []
			},
			readonly: {
				type: Boolean,
				default: false
			},
			placeholder: {
				type: String,
				default: ''
			},
			showDeleteButton: {
                type: Boolean,
                default: false
            },
			porlet: {
				type: Object,
				required: false
			},
			actions: {
				type: Array
			}
		},
		data () {
			return {
				callHook: (h, val) => val,
				render: val => val,
				error: null,
				editing: false,
				model: '',
				hideInput: false,
				loading: false,

				modelfilter: ''
			}
		},
		watch: {
			value() {
				this.model = _.cloneDeep(this.value)
			},
			loading(val) {
				this.$emit('update:busy',val)
			},
			editing() {
				if (this.input.keepalive && !this.editing) this.editing = this.input.keepalive
			},
			'input.class'() {
				if (this.input.class && this.input.class.includes('required')) {
					this.$emit('obligatorio')
				}
			}
		},
		computed: {

			showTooltip: {
				get () {

					if (this.mode === 'inline') return !!this.error

					return this.editing

				},
				set () {}
			},

			extraType () {

				const types = this.type.split(':')

				if (types.length < 2) return false

				return types[1]

			},

			mainType () { return this.type.split(':')[0] }
		},
		mounted () {
			
			this.model = _.cloneDeep(this.value)

			if (this.$refs.input && this.$refs.input.$_callHook) this.callHook = this.$refs.input.$_callHook

			if (this.$refs.input && this.$refs.input.$render) this.render = this.$refs.input.$render

			if (this.$refs.input && this.$refs.input.overrideData) Object.assign(this.$data, this.$refs.input.overrideData())

			// Mantener input abierto
			if(this.input) this.editing = this.input.keepalive
		},
		methods: {

			async save () {

				//console.log('save')
				try {

					let val = this.model
					//console.log('save: ',val)

					val = await this.callHook('beforeSave', val)
					
					if(this.obligatorio && !val ) {
						this.$emit('obligatorio')
						return
					}

					if (this.saveUrl !== '') {

						if (this.saveUrl === 'forzar error') throw {
							message: 'Algo sa rompido',
							type: 'Error'
						}

						if (this.saveUrl === 'forzar bien') {
							
							//console.log('chachi')

						} else {
							
							this.loading = true

							let resp = null

							if(this.input.format == 'file') {
								//console.log('enío file: ',val)

								let formData = new FormData();
                    			formData.append("image", val.file)

								resp = await updateInputFile(formData, {
									id: this.identificador,
									entidad: this.entidad,
									field: this.input.key
								})

							} else {
								
								let newvalue = val
								
								if(this.input.format == 'datepicker') {

									newvalue = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD')

								} else if(this.input.format == 'datetimepicker') {

									newvalue = moment(val, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
								}

								resp = await axios.post(this.saveUrl, {
									id: this.identificador,
									entidad: this.entidad,
									field: this.input.key,
									newvalue: `${this.modelfilter}${newvalue}`,
									format: this.input.format,
									entidadRelacionada: this.input.entidad
								})
							}
							//console.log(resp)

							// Actualizar componente
							/*if (resp.data.recargarComponentes && resp.data.recargarComponentes.length) {
								let _self = this
								resp.data.recargarComponentes.forEach(comp => {
									_self.$referencias[comp].refresh()
								})
							}*/

							this.loading = false
							
							if (resp && typeof resp.data !== "object") {

								throw {
									message: resp.errorMensaje || 'Ha ocurrido un error al guardar',
									type: 'Error'
								}

							} else if (resp.data.mensajes) {

								this.$emit('saved', resp.data)

							}
							
						}

					}

					val = await this.callHook('afterSave', val)

					this.$emit('input', val)

					this.model = val

					this.stopEditing()

				}
				catch (err) {
					
					this.error = err.response.data.errorMensaje

					if (this.$refs.input.focus) this.$refs.input.focus()

					this.loading = false

				}

			},

			async cancel () {
				
				try {

					let val = this.value

					val = await this.callHook('beforeCancel', val)

					val = await this.callHook('afterCancel', val)

					this.model = val

					this.stopEditing()

				}
				catch (err) {
					console.log(err)
					this.error = err.response.data.errorMensaje

					if (this.$refs.input.focus) this.$refs.input.focus()

				}

			},

			async onInput (val) {

				try {

					this.error = false

					val = await this.callHook('input', val)

					this.model = val

					if(this.saveUrl == '') {
						this.$emit('input', val)
					}

				} catch(err) {
					
					this.error = err.response.data.errorMensaje

					if (this.$refs.input.focus) this.$refs.input.focus()

				}

			},

			async ondblclick () {

				if(this.readonly || this.editing) return

				let val = this.model

				val = await this.callHook('startEditing', val)

				this.model = val

				this.editing = true

				setTimeout(() => {

					if (this.$refs.input.focus) this.$refs.input.focus()
					if (this.$refs.input.select) this.$refs.input.select()

				}, 100)

			},

			async stopEditing () {

				let val = this.model

				val = await this.callHook('endEditing', val)

				this.model = val

				this.editing = false

				this.error = false

				//setTimeout(() => this.$refs.a.focus(), 200)

			},

			async next (e) {

				if (this.siblings.length === 0) return

				let index = this.siblings.indexOf(this) + 1

				if (index > this.siblings.length - 1) index = 0
				
				if(this.model != this.value) {
					
					await this.save()
					if(this.error) return

				}
					
				this.stopEditing()
				
				//console.log('next', index)
				this.siblings[index].ondblclick()

			},

			async back (e) {

				if (this.siblings.length === 0) return

				let index = this.siblings.indexOf(this) - 1

				if (index < 0) index = this.siblings.length - 1

				if(this.model != this.value) {

					await this.save()
					if(this.error) return

				}
					
				this.stopEditing()
				
				//console.log('back', index)
				this.siblings[index].ondblclick()

			}

		}
	}
</script>

<style lang="scss">
	@import '@/assets/scss/variables.scss';
	form {
		&.align-right {
			.label, input {
				text-align: right!important;
			}
			.editing {
    			justify-content: flex-end;
			}
		}
		&.editable {
			.label {
				color: $--color-primary; //#d63031;
			}
			&:hover {
				background-color: $--color-editable; //#d630310d
				cursor: pointer;
			}
		}
		&.txt-left input,
		&.txt-left .truncate {
			text-align: left!important;
		}
		&.txt-center input,
		&.txt-center .truncate {
			text-align: center!important;
		}
		&.txt-right input,
		&.txt-right .truncate,
		&.txt-right .editing {
			text-align: right!important;
			justify-content: flex-end;
		}

		input {
			border-radius: 0px!important;
		}

		input, textarea {
			font-family: 'Nunito Sans'!important;
			padding: 0 0.50rem!important;
		}

	}

	.el-popover:focus {
		border: 1px solid #DCDFE6;
		border-radius: 5px;
		outline: 0;
	}

	.label {
		//min-height: 32px;
		line-height: 32px;
		padding: 0 0.50rem;
		border: 0px;
		box-sizing: border-box;
		color: #303133;
    	border-radius: 0px;

		&:focus {
			//border: 1px solid #DCDFE6;
			//border-radius: 5px;
			outline: 0;
		}

		&.align-right {
			text-align: right;
		}
		.truncate {
			overflow: hidden;
			text-overflow: ellipsis;
			&.placeholder {
				height: 32px;
			}
		}
		textarea {
			border: 0px;
			color: $--color-primary!important;
			padding: 0px!important;
			background-color: transparent;
		}
	}

	.holder {
		display: flex;
		justify-content: flex-end;

		&>div:first-child {
			flex-grow: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-size: 0.8rem;
		}

		&>div:last-child {
			display: flex;
			align-items: center;

			&.editing {
				flex-grow: 1;
				&.filter {
					flex-flow: column;
				}
			}

			&>.input-sigarus-component {
				flex-grow: 1;
			}

			&>.buttons {
				flex-shrink: 0;
				margin-left: 1px;

				&>* {
					margin-left: 1px !important;
				}

				&.buttons-editing {
					position: absolute;
    				right: -41px;
					z-index: 9;
				}

				> button {
					padding: 7px 15px;
				}
			}
		}
	}

	

</style>
